import { createAction } from '@reduxjs/toolkit';

const ActionsType = {
	ACTIVE_PAGE: 'data/activePage',
	SET_AGREEMENT: 'data/setAgreement',
};

const changeActivePage = createAction(ActionsType.ACTIVE_PAGE, (payload) => ({
	payload,
}));

const setAgreement = createAction(ActionsType.SET_AGREEMENT, (payload) => ({
	payload, // Сюда будем передавать true или false
}));

export { changeActivePage, setAgreement };

